'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArrowButtonUp = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.751 16.793L12.767 4.322a1.066 1.066 0 0 0-1.539 0L.249 16.793a.987.987 0 0 0 .107 1.414l1.85 1.557a1.028 1.028 0 0 0 1.438-.111l8.165-9.453a.25.25 0 0 1 .379 0l8.168 9.45a1.021 1.021 0 0 0 .7.349 1 1 0 0 0 .741-.238l1.851-1.558a.989.989 0 0 0 .107-1.414z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M20.976 20.014a.995.995 0 0 1-.754-.342l-8.218-9.678-8.209 9.668a.999.999 0 0 1-1.409.116L.557 18.216a.992.992 0 0 1-.347-.684.995.995 0 0 1 .26-.751l10.772-12.45a.993.993 0 0 1 .757-.346.997.997 0 0 1 .755.346l10.8 12.469a.991.991 0 0 1 .242.726.992.992 0 0 1-.342.685l-1.829 1.563a1 1 0 0 1-.649.24zM1.207 17.455l1.823 1.559 8.401-9.891a.744.744 0 0 1 1.145.002l8.396 9.888 1.812-1.545L11.996 4.983 1.207 17.455z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M4.287 19.502a1.53 1.53 0 0 1-1.065-.431L.424 16.35a1.486 1.486 0 0 1 .032-2.11L10.932 4.054a1.534 1.534 0 0 1 2.134-.002l10.482 10.192-.003-.003.027.027c.286.297.437.676.429 1.073-.008.397-.17.767-.456 1.042l-2.763 2.686a1.533 1.533 0 0 1-2.133.003L12 12.607l-6.648 6.464a1.53 1.53 0 0 1-1.065.431zm-.022-1.509a.031.031 0 0 0 .022.008c.01 0 .018-.003.025-.01l7.165-6.967a.745.745 0 0 1 .523-.212c.196 0 .382.075.522.212l7.168 6.969a.116.116 0 0 0 .028.004c.01 0 .015-.003.019-.007l2.756-2.679L12.022 5.129 12 5.121a.032.032 0 0 0-.025.011L1.506 15.311l2.759 2.682z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowButtonUp.displayName = 'IconArrowButtonUp';
exports.default = IconArrowButtonUp;